module.exports = __webpack_public_path__ + "static/media/back.5467f78c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/article/back.svg
// module id = 387
// module chunks = 0